document.addEventListener('DOMContentLoaded', () => {

	// Add class to footer columns when expanded or collapsed
	document.querySelectorAll('.js-footer-collapse').forEach(collapse => {
		collapse.addEventListener('show.bs.collapse', () => collapse.parentNode.classList.add('is-open'))
		collapse.addEventListener('hide.bs.collapse', () => collapse.parentNode.classList.remove('is-open'))
	})

})
